import { type FC } from 'react';
import cn from 'classnames';

import { type ArenaOffersDto } from '@/common/types/shop/marketBoxes';

import ProfitDropRewardCard from './ProfitDropRewardCard';

import profitDropIcon from '/img/shop/arenaOffers/profitDropIcon.svg';

interface RewardsListProps {
  rewards: Pick<
    ArenaOffersDto['reward'],
    'usdt' | 'tgem' | 'lottery' | 'arenaOffer'
  >;
  className?: string;
  chanceIcon?: boolean;
}

const ProfitDropRewardCardsList: FC<RewardsListProps> = ({
  rewards,
  className,
  chanceIcon,
}) => {
  return (
    <div className={cn('flex flex-col gap-4 items-center', className)}>
      <div
        className={cn(
          'grid grid-cols-[4rem_4rem] gap-1',
          !!chanceIcon && 'relative',
        )}
      >
        {chanceIcon && (
          <img
            className="w-[66%] top-[-10%] -right-[30%] aspect-square absolute z-10"
            src={profitDropIcon}
            alt="chance icon"
          />
        )}
        <ProfitDropRewardCard type="arenaOffer" value={rewards.arenaOffer} />
        <ProfitDropRewardCard type="lottery" value={rewards.lottery} />
        <ProfitDropRewardCard type="tgem" value={rewards.tgem} />
        <ProfitDropRewardCard type="usdt" value={rewards.usdt} />
      </div>
    </div>
  );
};

export default ProfitDropRewardCardsList;
